module.exports = __webpack_public_path__ + "static/media/cigarettes_02_thumb.cc9f2194.png";